import { render, staticRenderFns } from "./OJIntro.vue?vue&type=template&id=171b5ec8&scoped=true&"
import script from "./OJIntro.vue?vue&type=script&lang=ts&"
export * from "./OJIntro.vue?vue&type=script&lang=ts&"
import style0 from "./OJIntro.vue?vue&type=style&index=0&id=171b5ec8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171b5ec8",
  null
  
)

export default component.exports